// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as MenuActions from "../../resources/navigation/MenuActions.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as PromotionEditFormMutations from "./PromotionEditFormMutations.res.js";

function PromotionEditActions(props) {
  let status = props.status;
  let id = props.id;
  let scope = Auth.useScope();
  let startCampaign = PromotionEditFormMutations.useStartCampaign(id);
  let stopCampaign = PromotionEditFormMutations.useStopCampaign(id);
  if (status !== "ONGOING" && status !== "NOT_PROGRAMMED" && status !== "PROGRAMMED") {
    return null;
  }
  if (props.variation !== "actionBar") {
    return JsxRuntime.jsx(MenuActions.make, {
      children: JsxRuntime.jsx(MenuActions.Section.make, {
        children: status === "PROGRAMMED" ? JsxRuntime.jsx(MenuActions.Item.make, {
            title: I18n.t("Unschedule"),
            tone: "danger",
            onAction: () => {
              stopCampaign(status);
            }
          }) : (
            status === "NOT_PROGRAMMED" ? JsxRuntime.jsx(MenuActions.Item.make, {
                title: I18n.t("Schedule"),
                tone: "brand",
                onAction: () => {
                  startCampaign(status);
                }
              }) : (
                status === "ONGOING" ? JsxRuntime.jsx(MenuActions.Item.make, {
                    title: I18n.t("Stop"),
                    tone: "danger",
                    onAction: () => {
                      stopCampaign(status);
                    }
                  }) : null
              )
          )
      }),
      trigger: {
        TAG: "Compact",
        icon: "more_v2",
        size: "small",
        bold: true
      }
    });
  }
  if (status !== "ONGOING" && status !== "PROGRAMMED") {
    if (status === "NOT_PROGRAMMED" && scope.TAG !== "Organisation") {
      return JsxRuntime.jsx(Button.make, {
        label: I18n.t("Schedule"),
        variant: "solid",
        tone: "brand",
        onPress: () => {
          startCampaign(status);
        }
      });
    } else {
      return null;
    }
  }
  if (scope.TAG === "Organisation") {
    return null;
  }
  let label = status === "PROGRAMMED" ? I18n.t("Unschedule") : I18n.t("Stop");
  return JsxRuntime.jsx(Button.make, {
    label: label,
    tone: "danger",
    size: "medium",
    onPress: () => {
      stopCampaign(status);
    }
  });
}

let make = React.memo(PromotionEditActions);

let Mutations;

export {
  Mutations,
  make,
}
/* make Not a pure module */
